import { render, staticRenderFns } from "./UspBlock.vue?vue&type=template&id=6172d22e&scoped=true&"
import script from "./UspBlock.vue?vue&type=script&lang=js&"
export * from "./UspBlock.vue?vue&type=script&lang=js&"
import style0 from "./UspBlock.vue?vue&type=style&index=0&id=6172d22e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6172d22e",
  null
  
)

export default component.exports